import React, { useState } from "react";
import tabBar from "../../assets/images/special_id/ICON INACTIVE.png";
import activeTabBar from "../../assets/images/special_id/ICON ACTIVE.png";
import specialIDS from "../../assets/images/special_id/id.png";
import title from "../../assets/images/special_id/BIG TITRE.png";
import title6 from "../../assets/images/special_id/RULES SPECIAL ID.png";
import roles1 from "../../assets/images/special_id/roles 4.png";
import roles2 from "../../assets/images/special_id/roles 5.png";
import roles3 from "../../assets/images/special_id/roles 6.png";
import table1 from "../../assets/images/special_id/Group 12.png";
import table2 from "../../assets/images/special_id/1212 (1).png";
import table3 from "../../assets/images/special_id/1212 (2).png";
import table0 from "../../assets/images/special_id/Group 13.png";
import title1 from "../../assets/images/special_id/LOGO.png";
import cp_full1 from "../../assets/images/special_id/LOGO1.svga";
import cp_full12 from "../../assets/images/special_id/light.svga";
import SVGAPlayer from "./SVGAAnimation";

import { useTranslation } from "react-i18next";

const Design = () => {
  const [activeTab, setActiveTab] = useState("tab1");
  // Handle image error by updating the imageErrors state
  const urlParams = new URLSearchParams(window.location.search);

  const lang = urlParams.get("lang");

  const { t } = useTranslation();

  const renderTabContent = () => {
    if (activeTab === "tab1") {
      return (
        <div className="tab-panel mt-5 SpecialBackGroundTab relative pt-14 flex flex-col justify-start  gap-5 items-center text-center">
          <div className="event-tabs overflow-y-scroll h-[90%] z-40 relative w-full">
            {" "}
            <img
              src={lang == "ar" ? table0 : table3}
              alt=""
              className="w-[83%] relative -right-2 mx-auto"
            />
            <div
              dir={lang === "en" ? "rtl" : "ltr"}
              className="content w-[84%] mx-auto  my-2 flex flex-row justify-between items-center"
            >
              <p className="w-[92%] font-rubik font-medium text-[13px]">
                {t(
                  "If you require a different special ID outside the rules, please contact customer service (go to customer service)"
                )}
              </p>
              <img src={roles1} alt="" className="w-[10%]" />
            </div>
            <div
              dir={lang === "en" ? "rtl" : "ltr"}
              className="content w-[84%] mx-auto  my-2 flex flex-row justify-between items-center"
            >
              <p className="w-[92%] font-rubik font-medium text-[13px]">
                {t(
                  "If a user does not log in to the app for 90 consecutive days or is suspected of violating the rules, the official Tag Chat has the right to withdraw a special ID."
                )}
              </p>
              <img src={roles2} alt="" className="w-[10%]" />
            </div>
            <div
              dir={lang === "en" ? "rtl" : "ltr"}
              className="content w-[84%] mx-auto  my-2 flex flex-row justify-between items-center"
            >
              <p className="w-[92%] font-rubik font-medium text-[13px]">
                {t(
                  "In case of suspected use of illegal methods to obtain rewards, Tag Chat has the right to delete activity and reward data."
                )}
              </p>
              <img src={roles3} alt="" className="w-[10%]" />
            </div>
            <div
              dir={lang === "en" ? "rtl" : "ltr"}
              className="content w-[80%] mx-auto  my-2 flex flex-row justify-between items-center"
            >
              <p className="text-[#AA0F0F] font-rubik font-normal text-[12px]">
                {t(
                  "Tag Chat has the final right to interpret the activity, and this activity is not related to Apple Inc."
                )}
              </p>
            </div>
            <div
              dir={lang === "en" ? "rtl" : "ltr"}
              className="content w-[80%] mx-auto  my-2 flex flex-row justify-between items-center"
            >
              <p className="text-[#AA0F0F] font-rubik font-normal text-[12px]">
                {t(
                  "If you have any questions, please click here: (Contact customer service in the room)"
                )}
              </p>
            </div>
          </div>
        </div>
      );
    } else if (activeTab === "tab2") {
      return (
        <div className="tab-panel mt-5 SpecialBackGroundTab relative pt-14 flex flex-col justify-start  gap-5 items-center text-center">
          <div className="event-tabs overflow-y-scroll h-[93%] z-40 relative w-full">
            {" "}
            <img
              src={lang === "ar" ? table1 : table2}
              alt=""
              className="w-[83%] relative -right-1 mx-auto"
            />
            <div
              dir={lang === "en" ? "rtl" : "ltr"}
              className="content w-[84%] mx-auto  my-2 flex flex-row justify-between items-center"
            >
              <p className="w-[92%] font-rubik font-medium text-[13px]">
                {t(
                  "If you require a different special ID outside the rules, please contact customer service (go to customer service)"
                )}
              </p>
              <img src={roles1} alt="" className="w-[10%]" />
            </div>
            <div
              dir={lang === "en" ? "rtl" : "ltr"}
              className="content w-[84%] mx-auto  my-2 flex flex-row justify-between items-center"
            >
              <p className="w-[92%] font-rubik font-medium text-[13px]">
                {t(
                  "If a user does not log in to the app for 90 consecutive days or is suspected of violating the rules, the official Tag Chat has the right to withdraw a special ID."
                )}
              </p>
              <img src={roles2} alt="" className="w-[10%]" />
            </div>
            <div
              dir={lang === "en" ? "rtl" : "ltr"}
              className="content w-[84%] mx-auto  my-2 flex flex-row justify-between items-center"
            >
              <p className="w-[92%] font-rubik font-medium text-[13px]">
                {t(
                  "In case of suspected use of illegal methods to obtain rewards, Tag Chat has the right to delete activity and reward data."
                )}
              </p>
              <img src={roles3} alt="" className="w-[10%]" />
            </div>
            <div
              dir={lang === "en" ? "rtl" : "ltr"}
              className="content w-[80%] mx-auto  my-2 flex flex-row justify-between items-center"
            >
              <p className="text-[#AA0F0F] font-rubik font-normal text-[12px]">
                {t(
                  "Tag Chat has the final right to interpret the activity, and this activity is not related to Apple Inc."
                )}
              </p>
            </div>
            <div
              dir={lang === "en" ? "rtl" : "ltr"}
              className="content w-[80%] mx-auto  my-2 flex flex-row justify-between items-center"
            >
              <p className="text-[#AA0F0F] font-rubik font-normal text-[12px]">
                {t(
                  "If you have any questions, please click here: (Contact customer service in the room)"
                )}
              </p>
            </div>
          </div>
        </div>
      );
    }
  };
  return (
    <div className="bg-[#efe4bf] relative h-full overflow-hidden">
      <div className="SpecialId xs:h-[375px] sm:h-[399px] relative">
        <div className="relative w-full  ">
          <SVGAPlayer
            src={cp_full1}
            alt="background "
            className="h-[140px]  mx-auto w-[300px]"
          />
        </div>{" "}
        <div className="relative top-[-20px] w-full  ">
          <SVGAPlayer
            src={cp_full12}
            alt="background "
            className="h-[150px]  mx-auto w-[300px]"
          />
          <img
            src={specialIDS}
            alt="weekly Star Reward Background"
            className="h-[120px] left-1/2 top-[12px] transform -translate-x-1/2 absolute  w-[170px] mx-auto"
          />
        </div>{" "}
        <div className=" w-full top-[-22px] mx-auto  relative  ">
          <img src={title} alt="rules" className={` h-[90px] mx-auto`} />
          <img
            src={lang === "ar" ? title1 : title6}
            alt="rules"
            className={` absolute  left-1/2 transform -translate-x-1/2 w-[160px] ${
              lang === "ar" ? "h-[50px] top-5" : "h-[32px] top-8"
            } mx-auto`}
          />
        </div>{" "}
        <div className="relative w-full  "></div>{" "}
      </div>

      <div className="event-tabs top-[-35px] z-40 relative">
        <div className="flex top-4 relative flex-wrap  mx-auto  justify-around">
          {[
            {
              id: "tab1",
              label: "4 numbers",
              imgActive: activeTabBar,
              imgInactive: tabBar,
            },
            {
              id: "tab2",
              label: "5-7 numbers",
              imgActive: activeTabBar,
              imgInactive: tabBar,
            },
          ].map((tab) => (
            <div
              key={tab.id}
              className={` inline-block  relative w-[30%]  cursor-pointer `}
              onClick={() => setActiveTab(tab.id)}
            >
              <img
                src={activeTab == tab.id ? tab.imgActive : tab.imgInactive}
                alt="rules"
                className={`w-[90%] mx-auto`}
              />
              <p
                className={`absolute w-full top-1/2 font-rubik font-extrabold left-1/2 transform -translate-x-1/2 sm:-translate-y-1/2 xs:-translate-y-[50%]${
                  activeTab == tab.id ? " text-[#FBF184]" : " text-[#FFFFFF66]"
                } lg:text-xl md:text-base sm:text-sm xs:text-[1rem] font-normal  text-center`}
              >
                {t(tab.label)}
              </p>
            </div>
          ))}
        </div>
        {renderTabContent()}
      </div>
    </div>
  );
};

export default Design;
